import { render, staticRenderFns } from "./rounded-image.vue?vue&type=template&id=533d2545&"
import script from "./rounded-image.vue?vue&type=script&lang=js&"
export * from "./rounded-image.vue?vue&type=script&lang=js&"
import style0 from "./rounded-image.vue?vue&type=style&index=0&id=533d2545&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports